const { initAnalytics } = require('./analytics');

module.exports = {
    initAnalyticsNext: initAnalytics
};
